import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [

    {
        label: 'Projects',
        icon: 'align-justify',
        link: '/project',
        // badge: {
        //     variant: 'primary',
        //     text: '+',
        //     route: [{ outlets: { dialog: ['dialog', 'project'] } }]
        // }
    },


];

